import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export class Parallax {
    constructor(element, options = {}) {
        if (!element) return;

        this.element = element;
        this.options = {
            background: '.pane__background',
            ...options,
        };

        this.init();
    }

    init() {
        this.createParallax();
    }

    createParallax() {
        const tl = gsap.timeline();

        tl.to(this.element.querySelector(this.options.background), {
            y: '-20vh',
            ease: 'none',
            scrollTrigger: {
                trigger: this.element,
                start: 'top top',
                end: 'bottom top',
                markers: false,
                scrub: 1,
            },
        });
    }
}
